// extracted by mini-css-extract-plugin
export var root = "styles-module--root--ADXBZ";
export var content = "styles-module--content--2ekpR";
export var description = "styles-module--description--9zabZ";
export var map = "styles-module--map--NkLmK";